export enum ETotalScore {
    LOW = "Low",
    Medium = "Medium",
    HEIGH = "High",
    NO_DATA = "N/A",
}

export enum EIndustryAssess {
    ON_AVERAGE = "OnAvg",
    BELOW_AVERAGE = "BelowAvg",
    ABOVE_AVERAGE = "AboveAvg",
    NO_DATA = "",
}

export enum EcubeCategory {
    LOYALTY = "loyalty",
    CONSOLIDATION = "consolidation",
    COST = "cost",
    BRANDING = "branding",
}

interface ILoyalty {
    Value: number | string;
    IndustryAssess: EIndustryAssess;
}

interface IConsolidation {
    Value: number | string;
    IndustryAssess: EIndustryAssess;
}

interface ICost {
    Value: number | string;
    IndustryAssess: EIndustryAssess;
}
interface IBranding {
    Value: number | string;
    IndustryAssess: EIndustryAssess;
}

export interface IDifficulty {
    TotalScore: ETotalScore;
    Loyalty: ILoyalty;
    Consolidation: IConsolidation;
    Cost: ICost;
    Branding: IBranding;
}

export type RawData = {
    Difficulty: IDifficulty;
};
